/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import CancelAction from './CancelAction/index'
import DeleteAction from './DeleteAction/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Treatment/Content/Actions/Content/Delete/Content/Main/Content"
  
}) {
let deleteTreatmentHasAppointmentsValueData = fromData.useDataValue({ viewPath,
context: 'delete_treatment',
path: 'has_appointments',
})
let deleteTreatmentIsContractAppliedValueData = fromData.useDataValue({ viewPath,
context: 'delete_treatment',
path: 'is_contract_applied',
})
let aggregateData = fromAggregate.any(deleteTreatmentHasAppointmentsValueData, deleteTreatmentIsContractAppliedValueData)
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 text={aggregateData ? "Treatment cards can only be deleted if they are empty of appointments and are not tied to any financials." : "Are you sure you want to delete the treatment card?"}
 data="delete_treatment.has_appointments"
 data="delete_treatment.is_contract_applied"
 aggregate="/Data/aggregate.js any"
/>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsWhite,'--mt-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
/>
<DeleteAction
  viewPath={`${viewPath}/DeleteAction`}
/>
</div>
{children}
</React.Fragment>)
}